import React, { useEffect, useRef } from 'react'

import './styles/Alert.scss'

import { ApplicationState } from 'AppReducer'
import { useSelector, useDispatch } from 'react-redux'
import { clearAlert } from './redux/actions'

import { ReactComponent as Loader } from './assets/loader.svg'

const Alert: React.FC = () => {
  const btnRef = useRef<HTMLButtonElement>(null)
  const dispatch = useDispatch()
  const alert = useSelector((state: ApplicationState) => state.alertReducer.alert)

  function handleAlert (status: boolean): void {
    const alertParent = document.querySelector('.alert')
    const alertContent = alertParent ? alertParent.querySelector('.content') : null

    if (alertParent && alertContent) {
      if (status) {
        alertParent.classList.add('animated', 'fadeIn')
        alertContent.classList.add('animated', 'zoomIn')
        if (btnRef.current) {
          btnRef.current.focus()
        }
      } else if (alertParent.classList.contains('animated')) {
        alertParent.classList.add('fadeOut')
        alertContent.classList.add('zoomOut')

        setTimeout(() => {
          alertParent.classList.remove('animated', 'fadeIn', 'fadeOut')
          alertContent.classList.remove('animated', 'zoomIn', 'zoomOut')
        }, 500)
      }
    }
  }

  function closeAlert (): void {
    handleAlert(false)
    setTimeout(() => {
      dispatch(clearAlert())
    }, 500)
  }

  useEffect(() => {
    handleAlert(!!alert.isOpen)
  }, [alert])

  return (
    <div className='alert'>
      <div className='content'>
        {
          alert.code === 100 ? (
            <Loader width={133} height={133} />
          )
            : null
        }
        {
          alert.code && alert.code >= 200 && alert.code < 400 ? (
            <i className='fa fa-check-circle' style={{ color: 'green' }} />
          )
            : null
        }
        {
          alert.code && alert.code >= 400 && alert.code <= 500 ? (
            <i className='fa fa-times-circle' style={{ color: 'red' }} />
          )
            : null
        }

        <h1>{alert.title}</h1>
        <h4>{alert.message}</h4>

        <button ref={btnRef} onClick={closeAlert} className='primary col-6 margin-top-16'>
          Fechar
        </button>
      </div>
    </div>
  )
}

export default Alert
